"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OceanSecretStore = void 0;
var secret_store_client_1 = __importDefault(require("@oceanprotocol/secret-store-client"));
var utils_1 = require("../utils");
var Instantiable_abstract_1 = require("../Instantiable.abstract");
var OceanSecretStore = (function (_super) {
    __extends(OceanSecretStore, _super);
    function OceanSecretStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OceanSecretStore.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                instance = new OceanSecretStore();
                instance.setInstanceConfig(config);
                return [2, instance];
            });
        });
    };
    OceanSecretStore.prototype.encrypt = function (did, document, publisher) {
        return __awaiter(this, void 0, void 0, function () {
            var signature, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, publisher.getToken()];
                    case 1:
                        _a = (_b.sent());
                        if (_a) return [3, 3];
                        return [4, this.ocean.utils.signature.signText(utils_1.noDidPrefixed(did), publisher.getId(), publisher.getPassword())];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        signature = _a;
                        return [2, this.ocean.brizo.encrypt(utils_1.noDidPrefixed(did), signature, document, publisher.getId())];
                }
            });
        });
    };
    OceanSecretStore.prototype.decrypt = function (did, content, consumer, secretStoreUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.getSecretStoreByAccount(consumer, secretStoreUrl).decryptDocument(utils_1.noDidPrefixed(did), content)];
            });
        });
    };
    OceanSecretStore.prototype.getSecretStoreByAccount = function (account, secretStoreUrl) {
        var config = __assign({}, this.config);
        if (account) {
            config.address = account.getId();
        }
        if (account && account.getPassword()) {
            config.password = account.getPassword();
        }
        if (secretStoreUrl) {
            config.secretStoreUri = secretStoreUrl;
        }
        return this.getSecretStore(config);
    };
    OceanSecretStore.prototype.getSecretStore = function (config) {
        var secretStoreUri = config.secretStoreUri, parityUri = config.parityUri, password = config.password, address = config.address, threshold = config.threshold;
        config = { secretStoreUri: secretStoreUri, parityUri: parityUri, password: password, address: address, threshold: threshold };
        return new secret_store_client_1.default(config);
    };
    return OceanSecretStore;
}(Instantiable_abstract_1.Instantiable));
exports.OceanSecretStore = OceanSecretStore;
//# sourceMappingURL=OceanSecretStore.js.map